"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import { Component, Ref, PropSync, Vue } from "vue-property-decorator";
import LayoutHeader from "./LayoutHeader.vue";
export class LayoutMainUI {
  static component() {
    return this._component;
  }
  static init(component) {
    this._component = component;
  }
  static showDrawer(position) {
    if (position) {
      this._component._controller.direction = position;
    }
    this._component._controller.visible = true;
  }
}
LayoutMainUI._component = null;
export class DrawerMainUI {
  static component() {
    return this._component;
  }
  static init(component) {
    this._component = component;
  }
}
DrawerMainUI._component = null;
export class UiDrawerController {
  constructor(visible, direction) {
    this._visible = false;
    this._direction = "rtl";
    this._visible = visible;
    this._direction = direction;
  }
  set visible(visible) {
    this._visible = visible;
  }
  get visible() {
    return this._visible;
  }
  set direction(direction) {
    this._direction = direction;
  }
  get direction() {
    return this._direction;
  }
}
let LayoutMain = class extends Vue {
  created() {
    LayoutMainUI.init(this);
    DrawerMainUI.init(this.drawerElement);
  }
};
__decorateClass([
  Ref("drawer-element")
], LayoutMain.prototype, "drawerElement", 2);
__decorateClass([
  PropSync("controller", {
    type: UiDrawerController,
    default: () => {
      return new UiDrawerController(false, "rtl");
    }
  })
], LayoutMain.prototype, "_controller", 2);
LayoutMain = __decorateClass([
  Component({
    components: { LayoutHeader }
  })
], LayoutMain);
export {
  LayoutMain as default
};
